import { ApiService } from "./ApiService"

export class PaymentMethodService {

    static uri = '/payment-method';

    static get() {
        return ApiService.get(`${this.uri}`,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }
}